import { AxiosResponse } from 'axios'
import axios from 'lib/axios'

export interface ResponseTypes {
  status: string
  message: string
  data: any
}

export const closeEvaluation360 = async (userTestId: number, evaluatorUserTestId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/test360/close_test`

  const body = {
    user_test_id: userTestId,
    evaluator_user_test_id: evaluatorUserTestId,
  }

  try {
    const response: AxiosResponse<ResponseTypes> = await axios.post(PATH, body)
    return response.data
  } catch (error) {
    throw new Error('Error closing evaluation')
  }
}
